export default __webpack_public_path__ + "static/media/iconFilter.93a822b7.svg";